/* @flow */

import React, { useState } from "react";
import styles from "./styles.scss";
import { HashLink } from "react-router-hash-link";
import Box from "../../Box";
import { Accordion, ButtonLink } from "@crossroads/ui-components";
import PhoneIcon from "icons/phone.svg";
import ChatIcon from "icons/chat.svg";
import ChevronIcon from "icons/chevron.svg";
import { useTranslate } from "@awardit/react-use-translate";

const scrollWidthOffset = el => {
  const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
  const yOffset = Number.parseInt(styles.headerOffset, 10) * -1;
  window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
};

const TicketBox = () => {
  const t = useTranslate();
  return (
    <Box className={styles.box}>
      <h3><ChatIcon aria-label={t("ICONS.CHAT")} />{t("SUCCESS.CONTACT.TITLE")}</h3>
      <p dangerouslySetInnerHTML={{ __html: t("SUCCESS.CONTACT.INFO") }} />
      <ButtonLink
        to={t("META.HELPDESK_LINK")}
        className={styles.button}
        variant="primary"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t("SUCCESS.CONTACT.TITLE")}
      </ButtonLink>
    </Box>
  );
};

const CallBox = () => {
  const t = useTranslate();
  return (
    <Box className={styles.box}>
      <h3><PhoneIcon aria-label={t("ICONS.PHONE")} />{t("SUCCESS.CONTACT.CALL_US")}</h3>
      <p dangerouslySetInnerHTML={{ __html: t("SUCCESS.CONTACT.CALL_US_HOURS") }} />
      <ButtonLink
        to={`tel:${t("SUCCESS.CONTACT.CALL_US_PHONENUMBER")}`}
        className={styles.button}
        variant="primary"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t("SUCCESS.CONTACT.CALL_US")}
      </ButtonLink>
    </Box>
  );
};

const Help = () => {
  const [openSection, setOpenSection] = useState(null);
  const t = useTranslate();

  const toggleSection = (s: string) =>
    openSection === s ? setOpenSection(null) : setOpenSection(s);

  return (
    <div className={styles.block}>
      <h3>{t("PURCHASE_POINTS.FAQ.TITLE")}</h3>

      <div className={styles.container}>
        <div className={styles.left}>
          <div className={styles.left}>
            <Accordion
              id="first"
              title={t("PURCHASE_POINTS.FAQ.1.Q")}
              open={openSection === "first"}
              setOpen={() => toggleSection("first")}
              ToggleIcon={ChevronIcon}
              className={styles.accordion}
            >
              <p>{t("PURCHASE_POINTS.FAQ.1.A")}</p>
            </Accordion>

            <Accordion
              id="second"
              title={t("PURCHASE_POINTS.FAQ.2.Q")}
              open={openSection === "second"}
              setOpen={() => toggleSection("second")}
              ToggleIcon={ChevronIcon}
              className={styles.accordion}
            >
              <p>{t("PURCHASE_POINTS.FAQ.2.A")}</p>
            </Accordion>

            <Accordion
              id="third"
              title={t("PURCHASE_POINTS.FAQ.3.Q")}
              open={openSection === "third"}
              setOpen={() => toggleSection("third")}
              ToggleIcon={ChevronIcon}
              className={styles.accordion}
            >
              <p>{t("PURCHASE_POINTS.FAQ.3.A")}</p>
            </Accordion>

            <Accordion
              id="forth"
              title={t("PURCHASE_POINTS.FAQ.4.Q")}
              open={openSection === "forth"}
              setOpen={() => toggleSection("forth")}
              ToggleIcon={ChevronIcon}
              className={styles.accordion}
            >
              <p>{t("PURCHASE_POINTS.FAQ.4.A")}</p>
            </Accordion>
          </div>
          <p>
            <HashLink
              smooth
              scroll={el => scrollWidthOffset(el)}
              to={`${t("CUSTOMER_SERVICE.LINK")}#buy-and-transfer`}
            >
              {t("PURCHASE_POINTS.FAQ.VIEW_MORE")}
            </HashLink>
          </p>
        </div>
        <aside className={styles.right}>
          <TicketBox />
          <CallBox />
        </aside>
      </div>
    </div>
  );
};

export default Help;
